// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_x10","col":"styles_col__2Ta2y"};